<template>
    <div class="wrapper">
        <div class="main-bn">
            <div class="inner-wrapper">
                <div>
                    <city-changer v-if="isDesktop" :direction="'top-left-direction'"></city-changer>
                    <h1>БАЗА ПРОВЕРЕННЫХ ПОДРЯДЧИКОВ</h1>
                    <div class="alexey">Алексея Земскова</div>
                </div>
                <div class="guarantee"  @click="open(this.popups.howWorksModal)">
                    <div class="icon">
                        <div class="icon-wrap">
                            <svg-icon :name="'hand'" :width="19" :height="18"></svg-icon>
                        </div>
                    </div>
                    <div class="text">
                        <span>гарантия 100% на все работы</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="content --scrolling-content" id="scroll-block">
            <div>
                <div class="top-title df df-space-between">
                    <h2>каталог</h2>
                    <tooltip-component
                        :direction="'bottom-right-direction'"
                        :add-style="{width: 'auto'}"
                        :add-class-wrap="'city-changer__tooltip-wrap'"
                        :add-class="'city-changer'"
                        :isChangeablePos="false"
                        :is-btn-close="false"
                        v-if="!isDesktop">
                        <template v-slot:tooltipBtn>
                            <div class="change-city">
                                Москва и МО
                            </div>
                        </template>
                        <template v-slot:tooltipContent>
                            <div class="txt">
                                На данный момент мы работаем<br>только в Москве и области
                            </div>
                        </template>
                    </tooltip-component>
                </div>
                <template v-if="isDesktop">
                    <aside-sticky :marginTop="32+57" :marginBottom="32" >
                        <aside class="aside">
                            <div class="aside-catalog">
                                <catalog-items :class="'--main-catalog'"></catalog-items>
                            </div>
                        </aside>
                    </aside-sticky>
                </template>
                <template v-else>
                    <aside class="aside">
                        <div class="aside-catalog">
                            <catalog-items :class="'--main-catalog'"></catalog-items>
                        </div>
                    </aside>
                </template>
            </div>
            <div class="container-scroll" v-if="isDesktop">
                <div class="df df-space-between top-title">
                    <h2>{{currentCategory.name ? currentCategory.name : 'все офферы'}}</h2>
                    <tooltip-component
                        :direction="'bottom-right-direction'"
                        :add-style="{width: 'auto'}"
                        :add-class-wrap="'city-changer__tooltip-wrap'"
                        :add-class="'city-changer'"
                        :is-btn-close="false">
                        <template v-slot:tooltipBtn>
                            <div class="change-city">
                                Москва и МО
                            </div>
                        </template>
                        <template v-slot:tooltipContent>
                            <div class="txt">
                                На данный момент мы работаем<br>только в Москве и области
                            </div>
                        </template>
                    </tooltip-component>
                </div>
                <offers-items :code="$route.params.code"></offers-items>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CatalogItems from '@baza/components/CatalogItems.vue';
import OffersItems from '@baza/components/OffersItems.vue';
import AsideSticky from '@baza/components/AsideSticky.vue';
import { scrollTo } from '@baza/helpers/animate';
import TooltipComponent from '@baza/components/TooltipComponent.vue';
import CityChanger from '@baza/components/CityChanger.vue';

export default {
    name: 'MainPage',
    components: {
        CatalogItems,
        OffersItems,
        AsideSticky,
        TooltipComponent,
        CityChanger,
    },
    props: {
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    computed: {
        ...mapState({
            popups: (state) => state.popups.items,
            isDesktop: (state) => state.isDesktop,
        }),
        ...mapState('category', {
            items: (state) => state.items,
            load: (state) => state.load,
        }),
        currentCategory() {
            const item = this.items.find((i) => i.code === this.$route.params.code);
            return item || {};
        },
        pageTitle() {
            const base = 'БАЗА ПРОВЕРЕННЫХ ПОДРЯДЧИКОВ АЛЕКСЕЯ ЗЕМСКОВА';
            return this.currentCategory.name
                ? `${this.currentCategory.name} — ${base}`
                : base;
        },
    },
    watch: {
        pageTitle: {
            immediate: true,
            handler(val) {
                document.title = val;
            },
        },
        $route() {
            if (this.isDesktop) {
                scrollTo('#scroll-block', 0, 500);
            }
        },
    },
    methods: {
        ...mapActions('popups', [
            'open',
        ]),
    },
};
</script>

<style lang="sass">
.main-bn
    height: 394px
    width: 100%
    background-size: 320px
    background-position: 0px 127px
    background-image: url(../assets/img/main-bn-mob.webp)
    background-repeat: no-repeat
    background-color: $black1
    margin-bottom: 56px
    .city-changer__tooltip-wrap
      width: 73px
    +for-size(992)
        margin-bottom: 104px
        margin-bottom: 12px
    .inner-wrapper
        width: 100%
        height: inherit
        display: flex
        flex-direction: column
        align-items: center
        position: relative
        justify-content: space-between
        overflow: hidden
        padding: 24px 12px 16px 12px
        +for-size(992)
            align-items: flex-start
            width: 992px
            padding: 86px 48px 128px 48px
        +for-size(1440)
            max-width: 1440px
            width: 100%
            padding: 88px 48px 130px 48px
    +for-size(992)
        background-size: 1920px
        background-position: center 0px
        height: 544px
        background-image: url(../assets/img/main-bn-2.webp)
        padding: 0
        background-color: #000
        margin-bottom: 56px
    h1
        font-family: "Oswald", sans-serif
        text-align: center
        font-size: 26px
        line-height: 120%
        font-weight: 500
        color: $honey
        +for-size(992)
            font-size: 56px
            line-height: 120%
            width: 525px
            text-align: left
        +for-size(1440)
            width: 525px
    .alexey
        color: $gray1
        font-size: 20px
        line-height: 120%
        font-family: "Oswald", sans-serif
        text-align: center
        margin-top: 4px
        font-weight: 500
        text-transform: uppercase
        +for-size(992)
            font-size: 26px
            line-height: 120%
            text-align: left
            margin-top: 16px
    .guarantee
        display: flex
        align-items: center
        cursor: pointer
        font-family: "SF", math, sans-serif
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0)
        gap: 8px
        +for-size(992)
            display: flex
            align-self: flex-start
            align-items: center
            justify-content: space-between
            font-size: 16px
            padding: 8px 16px
            transition: all .15s ease
            width: 315px
            +background-gradient
        .icon
            width: 48px
            height: 48px
            position: relative
            display: flex
            align-items: center
            justify-content: center
            +background-gradient
            +for-size(992)
                justify-content: flex-start
                width: 40px
                height: 48px
                &:after
                    content: none
                &:before
                    content: none
            .svg-icon
                z-index: 1
                color: $black2
            .icon-wrap
                content: ''
                width: 32px
                height: 32px
                border-radius: 32px
                background-color: $honey
                display: block
                position: relative
                z-index: 2
                display: flex
                align-items: center
                justify-content: center
                filter: drop-shadow(0px 0px 10px rgba(231, 206, 39, 0.5))
        .text
            font-size: 12px
            text-transform: uppercase
            line-height: 120%
            color: $honey
            font-weight: 700
            padding: 16px 8px
            width: 240px
            height: 48px
            letter-spacing: 0.025em
            +background-gradient
            +for-size(992)
                width: 235px
                font-size: 14px
                line-height: 112%
                letter-spacing: 0.025em
                padding: 0
                height: auto
                &:after
                    content: none
                &:before
                    content: none
            span
                position: relative
                z-index: 2
                display: block
.catalog-section
    padding: 28px 12px 0
    +for-size(992)
        padding-top: 48px
    &__top
        display: flex
        align-items: center
        justify-content: space-between
        margin-bottom: 24px
        +for-size(992)
            margin-bottom: 32px
        h2
            font-size: 18px
            font-weight: 700
            +for-size(992)
                font-size: 40px
                line-height: 48px
                margin-right: 24px
                font-weight: 600
.change-city
    color: $honey
    font-size: 26px
    line-height: 120%
    font-family: "Oswald", sans-serif
    font-weight: 500
    text-transform: uppercase
.most-popular
    h2
        font-size: 18px
        font-weight: 700
        text-align: center
        margin-bottom: 24px
        margin-top: 48px
        +for-size(992)
            font-size: 40px
            line-height: 48px
            font-weight: 600
            text-align: left
            margin-top: 80px
            margin-bottom: 32px
.--scrolling-content
    display: block
    padding: 0 12px
    width: 100%
    +for-size(992)
        max-width: 896px
        padding: 0
    +for-size(1440)
        max-width: 1440px
    .change-city
        color: $honey
        font-size: 26px
        line-height: 120%
        font-family: "Oswald", sans-serif
        font-weight: 500
        text-transform: uppercase

    .top-title
        +for-size(992)
            flex-direction: column
            align-items: flex-start !important
        +for-size(1440)
            flex-direction: row
    .city-changer__tooltip-wrap
        margin-bottom: 24px
        +for-size(992)
            margin-bottom: 0
        .tooltip
            top: calc(100% - 8px)
    h2
        font-weight: 500
        font-size: 26px
        line-height: 120%
        color: $gray1
        text-align: center
        font-family: "Oswald", sans-serif
        margin-bottom: 24px
        text-transform: uppercase
        +for-size(992)
            text-align: left
            margin-bottom: 32px
    .container-scroll
        display: none
    +for-size(992)
        display: flex
        justify-content: space-between
        min-height: 1000px
        .container-scroll
            display: block
            .top-title
                margin-bottom: 32px
    +for-size(1440)
        .container-scroll
            .top-title
                margin-bottom: 0px
</style>
